import React from 'react';
import RateOutFitCard from '../templates/RateOutFitCard'
import RateOutFitCardHOC from './RateOutFitCardHOC'
//import Branding from '../templates/Branding'
import moment from 'moment'


class SingleOutfitCardHOC extends React.Component {

  render() {
    console.log('props', this.props)
     const card = this.props.card

     return (
        <RateOutFitCardHOC cardIndex={1} noShadow={this.props.noShadow} key={card.id+'a'} outfit={card} visible={true} />
      )
  }
}


export default SingleOutfitCardHOC;



// WEBPACK FOOTER //
// ./src/components/SingleOutfitCardHOC.js